module.exports = __webpack_public_path__ + "img/graphql.302485bd.png";